import HeaderMenuDrawer from '../../components/HeaderMenuDrawer';
import HeaderNavigation from '../../components/HeaderNavigation';
import HeaderWalletDrawer from '../../components/HeaderWalletDrawer';
import Logo from '../../components/Logo/Logo';

export const Header = () => {
  return (
    <header className="relative mb-4 flex items-center justify-start gap-6">
      <Logo />

      <div
        className="hidden justify-start md:flex lg:absolute lg:top-1/2 lg:left-1/2 lg:-translate-x-1/2
          lg:-translate-y-1/2 lg:items-center lg:justify-center"
      >
        <HeaderNavigation />
      </div>

      <div className="flex w-full items-center justify-end gap-4">
        <HeaderWalletDrawer />
        <HeaderMenuDrawer />
      </div>
      {/* <AMLWalletCheckAlert /> This is not used anymore, but maybe we'll need it in the future*/}
    </header>
  );
};
